import WCCContentASCIIEmojiRule from '../asciiEmoji';
import WCCContentAttachmentsDummyRule from '../attachmentsDummy';
import WCCContentRule from '../base';
import WCCContentEmailRule from '../email';
import WCCContentEmojiRule from '../emoji';
import WCCContentLinkRule from '../link';

const wccContentNoMediaRules = <Array<WCCContentRule>>[
    new WCCContentAttachmentsDummyRule(),
    new WCCContentEmailRule(),
    new WCCContentLinkRule(),
    new WCCContentEmojiRule(),
    new WCCContentASCIIEmojiRule()
]

export default wccContentNoMediaRules;